import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal, GenericModalButton, MessagePopup } from 'com-gyf-webcore-userinterfacecomponents';
import 'rc-dialog/assets/bootstrap.css';

class Footer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            intentoValidacion:false
        };
        //this.validateCuenta = this.validateCuenta.bind(this);
        this.validarNuevaSolicitud = this.validarNuevaSolicitud.bind(this);
    }

   /* validateCuenta() {
        this.props.validate(this.props.nuevaSolicitudCuenta, this.props.data);
    }*/

    validarNuevaSolicitud() {
        if(!this.props.tarjetas.esCuentaExistente){
            //SI SE TRATA DE UNA SOLICITUD NORMAL SE PROCEDE A VALIDAR LOS DATOS DE LA CUENTA ANTES DE FINALIZARLA
            
            this.setState({intentoValidacion:true})
            this.props.validarNSC(this.props.tarjetas.solicitudCuenta);
        }else{
            this.props.guardarAdicionalCuentaExistente(this.props.tarjetas.solicitudCuenta)
        }
    }

    routeToNuevaSolicitudCuenta() {
        this.props.routeToNuevaSolicitudCuenta();
    }

    routeToVistaCliente() {
        $('#CancelAdicional').modal('toggle');
    }

    render() {
        const { screen, routeToBack, routeToNext, validate, data, showPopUpCancelAdic, routeToNuevaSolicitudCuenta, routeToVistaCliente, closePopUp, guardarBorrador } = this.props;
        let lastButton = <button onClick={() => this.routeToNuevaSolicitudCuenta()} className="btn btn-secondary">&#60; Anterior</button>
        let cancelButton = <button onClick={() => this.routeToVistaCliente()} className="btn btn-secondary" data-target="#CancelAdicional">Cancelar</button>
        let borradorButton = <GenericSimpleButton buttonType="button" text="Guardar borrador" buttonClass="btn btn-secondary" onClick={guardarBorrador} />
        let saveButton = <GenericSimpleButton buttonType="button" text="Finalizar" buttonClass="btn btn-cta" onClick={this.validarNuevaSolicitud} buttonType="button" />

        //SI YA SE INTENTÓ FINALIZAR LA SOLICITUD Y AÚN NO REDIRECCIONÓ, SE DEBE ITERAR SOBRE LOS CAMPOS A VALIDAR EN LA SOLICITUD PARA VER SI HAY FALTANTES/ERRORES Y VOLVER A NuevaSolicitudCuenta
        if(this.state.intentoValidacion){
            for (let prop in this.props.NSC.ERROR_CUENTA){
                if(this.props.NSC.ERROR_CUENTA[prop] == false) this.routeToNuevaSolicitudCuenta()
            }
        }
        
        return (
            <div className="row top-separator-md">
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-12">
                            {!this.props.esCuentaExistente && lastButton}
                            <div style={{ marginLeft: "29px", display: "inline-block" }}>
                                {!this.props.esCuentaExistente &&cancelButton}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-12">
                            <div style={{ float: "right" }}>
                            <div style={{ marginLeft: "29px", display: "inline-block" }}>
                                {this.props.esCuentaExistente &&cancelButton}
                            </div>
                                {/* TODO: se comenta componente del Boton 'Guardar Borrador' por que no está desarrollado por completo
                                borradorButton
                                */}

                                <div style={{ marginLeft: "29px", display: "inline-block" }}>
                                    {saveButton}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <GenericModal type="ALL_CUSTOM"
                    className="modal fade-out"
                    id="confirmCancelationAdicional"
                    screenSize="modal-dialog modal-generic"
                    header={
                        <h2 className="modal-title">Solicitud de Confirmación</h2>}
                    footer={
                        <div className="row">
                            <div className="col-xs-4">
                                <button className="btn btn-primary btn-cta" onClick={() => rootToVistaCliente(closePopUp)}>Aceptar</button>
                            </div>
                            <div className="col-xs-8">
                                <GenericSimpleButton text="Cancelar" dataDismiss="modal" buttonClass="btn btn-default btn-secondary" />
                            </div>
                        </div>}
                    body={<p>{"¿Confirma que desea descartar los cambios realizados sobre el adicional?"}</p>} />

            </div>
        )
    }
}

export default Footer;